import React from 'react';
import { schema as nSchema } from 'normalizr';
import _ from 'lodash';
import { createAPIActions } from 'barnyard/utils';
import { Tooltip, Select, Option } from 'barnyard/components';
import {
  Field
} from 'redux-form';
import { Row, Col } from 'barnyard/layouts';
import { BarnyardIcon } from 'barnyard/icons';
import { APP_URL } from '~/app/corporate/core/constants';

export const NAME = 'settings';
export const CLINICS_BASE_URL = `/${APP_URL}/${NAME}/clinics`;
export const CLINICS_ADD_URL = `${CLINICS_BASE_URL}/add`;

export const COMPARISONS_FETCH_SUCCESS = `${NAME}/COMPARISONS_FETCH_SUCCESS`;
export const COMPARISON_FETCH_SUCCESS = `${NAME}/COMPARISON_FETCH_SUCCESS`;
export const VENDOR_BLACKLIST_LIST = createAPIActions(`${NAME}/VENDOR_BLACKLIST_LIST`);
export const VENDOR_BLACKLIST_UPDATE = createAPIActions(`${NAME}/VENDOR_BLACKLIST_UPDATE`);
export const CLINICS_FETCH = createAPIActions(`${NAME}/CLINICS_FETCH`);
export const CLINIC_UPDATE = createAPIActions(`${NAME}/CLINIC_UPDATE`);
export const CLINIC_CREATE = createAPIActions(`${NAME}/CLINIC_CREATE`);
export const CLINIC_FETCH = createAPIActions(`${NAME}/CLINIC_FETCH`);
export const CLINICS_BULK_UPDATE = createAPIActions(`${NAME}/CLINICS_BULK_UPDATE`);
export const CLINIC_USER_UPDATE = createAPIActions(`${NAME}/CLINIC_USER_UPDATE`);
export const CLINIC_USER_INVITE = createAPIActions(`${NAME}/CLINIC_USER_INVITE`);
export const CLINIC_USER_REVOKE = createAPIActions(`${NAME}/CLINIC_USER_REVOKE`);

export const GET_PENDING_BUYERS = createAPIActions(`${NAME}/GET_PENDING_BUYERS`);
export const APPROVE_BUYER = createAPIActions(`${NAME}/APPROVE_BUYER`);
export const DENY_BUYER = createAPIActions(`${NAME}/DENY_BUYER`);
export const REMOVE_BUYER = createAPIActions(`${NAME}/REMOVE_BUYER`);
export const CORPORATE_USERS_FETCH = createAPIActions('CORPORATE_USERS_FETCH');
export const CORPORATE_USERS_UPDATE = createAPIActions('CORPORATE_USERS_UPDATE');
export const CORPORATE_USERS_CREATE = createAPIActions('CORPORATE_USERS_CREATE');
export const CORPORATE_USERS_INVITE = createAPIActions('CORPORATE_USERS_INVITE');
export const CORPORATE_USERS_DELETE = createAPIActions('CORPORATE_USERS_DELETE');

export const ITEM_LINKS_CREATE = createAPIActions(`${NAME}/ITEM_LINKS_CREATE`);
export const ITEM_LINKS_FETCH = createAPIActions(`${NAME}/ITEM_LINKS_FETCH`);
export const ITEM_LINKS_UPDATE = createAPIActions(`${NAME}/ITEM_LINKS_UPDATE`);
export const ITEM_LINKS_DELETE = createAPIActions(`${NAME}/ITEM_LINKS_DELETE`);
export const ITEM_SEARCH = createAPIActions(`${NAME}/ITEM_SEARCH`);
export const GLCODE_ITEM_SEARCH = createAPIActions(`${NAME}/GLCODE_ITEM_SEARCH`);
export const GLCODE_ITEM_FETCH = createAPIActions(`${NAME}/GLCODE_ITEM_FETCH`);

export const BUDGET_EXCLUDED_ITEMS_FETCH = createAPIActions(`${NAME}/BUDGET_EXCLUDED_ITEMS_FETCH`);
export const BUDGET_EXCLUDED_ITEMS_ADD = createAPIActions(`${NAME}/BUDGET_EXCLUDED_ITEMS_ADD`);
export const BUDGET_EXCLUDED_ITEMS_REMOVE = createAPIActions(`${NAME}/BUDGET_EXCLUDED_ITEMS_REMOVE`);
export const BUDGET_EXCLUDED_ITEMS_SEARCH = createAPIActions(`${NAME}/BUDGET_EXCLUDED_ITEMS_SEARCH`);

export const CORPORATE_CLINIC_USER_TAGS_FETCH = createAPIActions(`${NAME}/CORPORATE_CLINIC_USER_TAGS_FETCH`);
export const CATEGORY_GL_FETCH = createAPIActions(`${NAME}/CATEGORY_GL_FETCH`);

export const CORPORATE_INVENTORIED_ITEMS_FETCH = createAPIActions(`${NAME}/CORPORATE_INVENTORIED_ITEMS_FETCH`);
export const CORPORATE_INVENTORIED_ITEMS_CREATE = createAPIActions(`${NAME}/CORPORATE_INVENTORIED_ITEMS_CREATE`);
export const CORPORATE_INVENTORIED_ITEMS_UPDATE = createAPIActions(`${NAME}/CORPORATE_INVENTORIED_ITEMS_UPDATE`);
export const CORPORATE_INVENTORIED_ITEMS_DELETE = createAPIActions(`${NAME}/CORPORATE_INVENTORIED_ITEMS_DELETE`);

export const INVENTORIED_ITEM_TYPES = {
  CUSTOM_ITEM: 'custom',
  VETCOVE_ITEM: 'vetcove',
};

export const CLINIC_FETCH_STATUS = {
  /** Basic clinic data */
  MINIMAL: 'minimal',
  /** Complete clinic data */
  FULL: 'full'
};

const corporateusers = new nSchema.Entity('corporateusers');
const permissions = new nSchema.Entity('permissions');
const vendorlinks = new nSchema.Entity('vendorlinks');

export const schema = {
  corporateusers,
  permissions,
  vendorlinks
};

const renderSelectField = (name, title, read, full, admin, body) => (
  <Row align='middle' gutter='xs'>
    <Col span={11} >
      <Field
        name={name}
        size='small'
        component={Select}
        label={ <Row align='middle' gutter='xs'>
          <Col span={0} >
            {title}
          </Col>
          <Col span={0} >
            <Tooltip
              className='rPermissions__tooltip'
              body={<p>{body}</p>}
            >
              <BarnyardIcon icon={['fal', 'question-circle']} />
            </Tooltip>
          </Col>
        </Row>}
      >
        <Option value='' >None</Option>
        {read && <Option value={read} >Read</Option>}
        {full && <Option value={full} >Full</Option>}
        {admin && <Option value={admin} >Admin</Option>}
      </Field>
    </Col>
  </Row>
);

const renderSelectFieldAllPerm = (name, title, read, full, body) => (
  <Col span={4} >
    <Col span={11} >
      <Field
        name={name}
        size='small'
        component={Select}
        label={ <Row align='middle' gutter='xs'>
          <Col span={0} >
            {title}
          </Col>
          <Col span={0} >
            <Tooltip
              className='rPermissions__tooltip'
              body={<p>{body}</p>}
            >
              <BarnyardIcon icon={['fal', 'question-circle']} />
            </Tooltip>
          </Col>
        </Row>}
      >
        <Option value='' >None</Option>
        {read && <Option value={read} >Read</Option>}
        {full && <Option value={full} >Full</Option>}
      </Field>
    </Col>
  </Col>
);

export const CORPORATE_PERMISSION_CUSTOM = {
  SCRIPTS_ASSIGN_CALLER: {
    full: 'SCRIPTS_ASSIGN_CALLERS',
    name: 'assign_callers',
    label: <Row align='middle' gutter='xs'>
      <Col span={11} >
        <Field
          name='assign_callers'
          size='small'
          component={Select}
          label={<Row align='middle' gutter='xs'>
            <Col span={0} >
                Assign Callers
            </Col>
            <Col span={0} >
              <Tooltip
                className='rPermissions__tooltip'
                body={<p>This permission gives users ability to assign callers for prescriptions.</p>}
              >
                <BarnyardIcon icon={['fal', 'question-circle']} />
              </Tooltip>
            </Col>
          </Row>}
        >
          <Option value='SCRIPTS_ASSIGN_CALLERS'>Can assign callers</Option>
          <Option value=''>Can not assign callers</Option>
        </Field>
      </Col>
    </Row>,
    description: 'Assign prescription callers'
  },
  SCRIPTS_BE_A_CALLER: {
    full: 'SCRIPTS_CALLER',
    name: 'be_a_caller',
    label: <Row align='middle' gutter='xs'>
      <Col span={11} >
        <Field
          name='be_a_caller'
          size='small'
          component={Select}
          label={<Row align='middle' gutter='xs'>
            <Col span={0} >
                Be assigned as script caller
            </Col>
            <Col span={0} >
              <Tooltip
                className='rPermissions__tooltip'
                body={<p>This permission gives users ability to be assigned as callers for prescriptions.</p>}
              >
                <BarnyardIcon icon={['fal', 'question-circle']} />
              </Tooltip>
            </Col>
          </Row>}
        >
          <Option value='SCRIPTS_CALLER'>Can be assigned</Option>
          <Option value=''>Can not be assigned</Option>
        </Field>
      </Col>
    </Row>,
    description: 'Be assigned a prescription caller'
  },
  MANAGE_PERMISSIONS: {
    read: 'MANAGE_PERMISSIONS_READ',
    full: 'MANAGE_PERMISSIONS_FULL',
    name: 'manage',
    label: renderSelectField(
      'manage',
      'Permissions',
      'MANAGE_PERMISSIONS_READ',
      'MANAGE_PERMISSIONS_FULL',
      null,
      'This permission gives users access to permission groups and what groups each user belongs to.'
    ),
    description: 'Permissions',
    forBuyingGroup: true
  },
  MANAGE_CORPORATE: {
    read: 'MANAGE_CORPORATE_READ',
    full: 'MANAGE_CORPORATE_FULL',
    name: 'corporate',
    label: renderSelectField(
      'corporate',
      'Corporate Information',
      'MANAGE_CORPORATE_READ',
      'MANAGE_CORPORATE_FULL',
      null,
      'This permission gives users access to information about this corporate group.'
    ),
    description: 'Corporate Information',
    forBuyingGroup: false
  },
  CLINIC_PEEK: {
    read: 'CLINIC_PEEK',
    name: 'peek',
    label: renderSelectField(
      'peek',
      'Clinic Peek',
      'CLINIC_PEEK',
      null,
      null,
      'This permission lets users peek into clinic accounts.'
    ),
    description: 'Clinic Peek',
    forBuyingGroup: true
  },
  CLINIC_ORDER: {
    read: 'CLINIC_ORDER',
    name: 'orders',
    label: renderSelectField(
      'orders',
      'Clinic Orders',
      'CLINIC_ORDER',
      null,
      null,
      'This permission lets users view clinic orders and order analytics.'
    ),
    description: 'Clinic Orders',
    forBuyingGroup: true
  },
  COMMIT_AND_SAVE: {
    read: 'COMMIT_AND_SAVE_READ',
    full: 'COMMIT_AND_SAVE_FULL',
    name: 'commit_and_save',
    label: renderSelectField(
      'commit_and_save',
      'Commit and Save',
      'COMMIT_AND_SAVE_READ',
      'COMMIT_AND_SAVE_FULL',
      null,
      'This permission gives users access to commit and save dashboard.'
    ),
    description: 'Commit and Save',
    forBuyingGroup: false
  },
  CONTRACT_AUDIT: {
    read: 'CONTRACT_AUDIT_READ',
    full: 'CONTRACT_AUDIT_FULL',
    name: 'contract_audit',
    label: renderSelectField(
      'contract_audit',
      'Contract Audit',
      'CONTRACT_AUDIT_READ',
      'CONTRACT_AUDIT_FULL',
      null,
      'This permission gives users access to corporate contracts.'
    ),
    description: 'Contract Audit',
    forBuyingGroup: false
  },
  REQUISTION: {
    read: 'REQUISTION_READ',
    full: 'REQUISTION_FULL',
    name: 'requisitions',
    label: renderSelectField(
      'requisitions',
      'Requisition Requests',
      'REQUISTION_READ',
      'REQUISTION_FULL',
      null,
      'This permission gives users access to clinic requisition requests.'
    ),
    description: 'Requisition Requests',
    forBuyingGroup: false
  },
  REGIONS: {
    read: 'REGIONS_READ',
    full: 'REGIONS_FULL',
    name: 'regions',
    label: renderSelectField(
      'regions',
      'Manage Regions',
      'REGIONS_READ',
      'REGIONS_FULL',
      null,
      'This permission gives users access to how clinics are broken up into regions.'
    ),
    description: 'Regions',
    forBuyingGroup: true
  },
  SSO_MANAGE: {
    read: 'SSO_MANAGE_READ',
    full: 'SSO_MANAGE_FULL',
    name: 'sso_manage',
    label: renderSelectField(
      'sso_manage',
      'SSO Manage',
      'SSO_MANAGE_READ',
      'SSO_MANAGE_FULL',
      null,
      'This permission gives users access to SSO sign in settings.'
    ),
    description: 'SSO Manage',
    forBuyingGroup: false
  },
  SUPPLIER_ACCOUNTS: {
    read: 'SUPPLIER_ACCOUNTS_READ',
    full: 'SUPPLIER_ACCOUNTS_FULL',
    name: 'suppliers',
    label: renderSelectField(
      'suppliers',
      'Supplier Accounts',
      'SUPPLIER_ACCOUNTS_READ',
      'SUPPLIER_ACCOUNTS_FULL',
      null,
      'This permission gives users access to master credentials for supplier accounts.'
    ),
    description: 'Supplier Accounts',
    forBuyingGroup: false
  },
  BUDGETS: {
    read: 'BUDGETS_READ',
    full: 'BUDGETS_FULL',
    name: 'budgets',
    label: renderSelectField(
      'budgets',
      'Budgets',
      'BUDGETS_READ',
      'BUDGETS_FULL',
      null,
      'This permission gives users access to clinic budgets.'
    ),
    description: 'Budgets',
    forBuyingGroup: false
  },
  ALERTS: {
    read: 'ALERTS_READ',
    full: 'ALERTS_FULL',
    name: 'alerts',
    label: renderSelectField(
      'alerts',
      'Corporate Alerts',
      'ALERTS_READ',
      'ALERTS_FULL',
      null,
      'This permission gives users access to corporate alerts.'
    ),
    description: 'Corporate Alerts',
    forBuyingGroup: false
  },
  MISSED_SAVINGS: {
    read: 'MISSED_SAVINGS_READ',
    name: 'savings',
    label: renderSelectField(
      'savings',
      'Missed Savings',
      'MISSED_SAVINGS_READ',
      null,
      null,
      'This permission lets users view missed savings analytics.'
    ),
    span: 12,
    description: 'Missed Savings',
    forBuyingGroup: false
  },
  PRICE_COMPARE: {
    read: 'PRICE_COMPARE_READ',
    full: 'PRICE_COMPARE_FULL',
    name: 'price_compare',
    label: renderSelectField(
      'compare',
      'Price Compare',
      'PRICE_COMPARE_READ',
      'PRICE_COMPARE_FULL',
      null,
      'This permission gives users access to price compares.'
    ),
    description: 'Price Compares',
    forBuyingGroup: false
  },
  GUIDANCE: {
    read: 'GUIDANCE_READ',
    full: 'GUIDANCE_FULL',
    name: 'guidance',
    label: renderSelectField(
      'guidance',
      'Guidance',
      'GUIDANCE_READ',
      'GUIDANCE_FULL',
      null,
      'This permission gives users access to corporate guidance settings.'
    ),
    description: 'Guidance',
    forBuyingGroup: true
  },
  CASHBACK: {
    read: 'CASHBACK_READ',
    name: 'cashback',
    label: renderSelectField(
      'cashback',
      'Cashback',
      'CASHBACK_READ',
      null,
      null,
      'This permission lets users view cashback earned.'
    ),
    description: 'Cashback',
    forBuyingGroup: false
  },
  VENDOR_BLACKLIST: {
    read: 'VENDOR_BLACKLIST_READ',
    full: 'VENDOR_BLACKLIST_FULL',
    name: 'vendor',
    label: renderSelectField(
      'vendor',
      'Vendors',
      'VENDOR_BLACKLIST_READ',
      'VENDOR_BLACKLIST_FULL',
      null,
      'This permission gives users control of the vendors that appear on Vetcove.'
    ),
    description: 'Vendors',
    forBuyingGroup: false
  },
  CLINIC_INFO: {
    read: 'CLINIC_INFO_READ',
    full: 'CLINIC_INFO_FULL',
    name: 'clinics',
    label: renderSelectField(
      'clinics',
      'Clinic Information',
      'CLINIC_INFO_READ',
      'CLINIC_INFO_FULL',
      null,
      'This permission gives users access to clinic information.'
    ),
    description: 'Clinic Information',
    forBuyingGroup: true
  },
  INVOICE_STATEMENTS: {
    read: 'INVOICE_STATEMENTS_READ',
    full: 'INVOICE_STATEMENTS_FULL',
    name: 'invoice_statements',
    label: renderSelectField(
      'invoice statements',
      'Invoice Statements',
      'INVOICE_STATEMENTS_READ',
      'INVOICE_STATEMENTS_FULL',
      null,
      'This permission gives users access to invoice statements.'
    ),
    description: 'Invoice Statements',
    forBuyingGroup: false
  },
  INVOICES: {
    read: 'INVOICES_READ',
    full: 'INVOICES_FULL',
    name: 'invoices',
    label: renderSelectField(
      'invoices',
      'Invoices',
      'INVOICES_READ',
      'INVOICES_FULL',
      null,
      'This permission gives users access to invoices.'
    ),
    description: 'Invoices',
    forBuyingGroup: false
  },
  MESSAGES: {
    read: 'MESSAGES_READ',
    full: 'MESSAGES_FULL',
    name: 'messages',
    label: renderSelectField(
      'messages',
      'Announcements',
      'MESSAGES_READ',
      'MESSAGES_FULL',
      null,
      'This permission gives users access to announcements that are shown to clinics.'
    ),
    description: 'Announcements',
    forBuyingGroup: true
  },
  GLCODES: {
    full: 'GLCODES_FULL',
    name: 'glcodes',
    label: renderSelectField(
      'glcodes',
      'Gl Codes',
      null,
      'GLCODES_FULL',
      null,
      'This permission gives users the ability to create and update gl codes.'
    ),
    description: 'Gl Codes',
    forBuyingGroup: false
  },
  REGIONS_ACCESSIBLE: {
    read: 'ALL_REGIONS_ACCESS',
    name: 'regions_accessible',
    label: (
      <Row align='middle' gutter='xs'>
        <Col span={11} >
          <Field
            name='regions_accessible'
            size='small'
            component={Select}
            label={ <Row align='middle' gutter='xs'>
              <Col span={0} >
              Accessible Regions
              </Col>
              <Col span={0} >
                <Tooltip
                  className='rPermissions__tooltip'
                  body={<p>This permission lets users view all clinic information across all regions.</p>}
                >
                  <BarnyardIcon icon={['fal', 'question-circle']} />
                </Tooltip>
              </Col>
            </Row>}
          >
            <Option value='' >Limited</Option>
            <Option value='ALL_REGIONS_ACCESS' >All</Option>
          </Field>
        </Col>
      </Row>
    ),
    span: 12,
    description: 'All Regions Accessible',
    forBuyingGroup: false
  },
  APPROVAL_RULES: {
    read: 'APPROVAL_RULES_READ',
    full: 'APPROVAL_RULES_FULL',
    name: 'approval_rules',
    label: renderSelectField(
      'approval_rules',
      'Approval Rules',
      'APPROVAL_RULES_READ',
      'APPROVAL_RULES_FULL',
      null,
      'This permission gives users access to rules that determine which orders required approval.'
    ),
    description: 'Approval Rules',
    forBuyingGroup: false
  },
  APPROVAL_ORDERS: {
    read: 'APPROVAL_ORDERS_READ',
    full: 'APPROVAL_ORDERS_FULL',
    admin: 'APPROVAL_ORDERS_ADMIN',
    name: 'approval_orders',
    label: renderSelectField(
      'approval_orders',
      'Approval Orders',
      'APPROVAL_ORDERS_READ',
      'APPROVAL_ORDERS_FULL',
      'APPROVAL_ORDERS_ADMIN',
      'This permission gives users access to orders that require approval.',
    ),
    description: 'Approval Orders',
    forBuyingGroup: false
  },
  ITEM_LINKS: {
    read: 'ITEM_LINKS_READ',
    full: 'ITEM_LINKS_FULL',
    name: 'item_links',
    label: <Row align='middle' gutter='xs'>
      <Col span={11} >
        <Field
          name='item_links'
          size='small'
          component={Select}
          label={<Row align='middle' gutter='xs'>
            <Col span={0} >
              Item Links
            </Col>
            <Col span={0} >
              <Tooltip
                className='rPermissions__tooltip'
                body={<p>This permission gives users access to external item links.</p>}
              >
                <BarnyardIcon icon={['fal', 'question-circle']} />
              </Tooltip>
            </Col>
          </Row>}
        >
          <Option value='ITEM_LINKS_READ'>Read</Option>
          <Option value='ITEM_LINKS_FULL'>Full</Option>
        </Field>
      </Col>
    </Row>,
    description: 'Item Links'
  }
};

export const CORPORATE_PERMISSION_GLOBAL = {
  ALL_PERMISSIONS: {
    full: 'ALL_PERMISSIONS_FULL',
    read: 'ALL_PERMISSIONS_READ',
    name: 'all',
    label: renderSelectFieldAllPerm(
      'all',
      'All Permissions',
      'ALL_PERMISSIONS_READ',
      'ALL_PERMISSIONS_FULL',
      'This permission gives users access to everything in the corporate portal.'
    ),
    description: 'All Permissions',
    forBuyingGroup: true
  }
};

export const CORPORATE_PERMISSION_LEVELS = Object.assign(
  {},
  CORPORATE_PERMISSION_CUSTOM,
  CORPORATE_PERMISSION_GLOBAL
);

export const CORPORATE_PERMISSION_ALPHABETICAL = _.orderBy(
  CORPORATE_PERMISSION_LEVELS, [permission => permission.description.toLowerCase()]
);

export const CORPORATE_PERMISSION_CUSTOM_ALPHABETICAL = _.orderBy(
  CORPORATE_PERMISSION_CUSTOM, [permission => permission.description.toLowerCase()]
);

export const CORPORATE_PERMISSIONS_READ = {
  ALL_PERMISSIONS_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
  ],
  MANAGE_PERMISSIONS_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.MANAGE_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.MANAGE_PERMISSIONS.full
  ],
  MANAGE_PERMISSIONS_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.MANAGE_PERMISSIONS.full
  ],
  MANAGE_CORPORATE_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.MANAGE_CORPORATE.read,
    CORPORATE_PERMISSION_LEVELS.MANAGE_CORPORATE.full
  ],
  MANAGE_CORPORATE_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.MANAGE_CORPORATE.full
  ],
  CLINIC_PEEK: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.CLINIC_PEEK.read
  ],
  CLINIC_ORDER: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.CLINIC_ORDER.read
  ],
  COMMIT_AND_SAVE_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.COMMIT_AND_SAVE.read,
    CORPORATE_PERMISSION_LEVELS.COMMIT_AND_SAVE.full
  ],
  COMMIT_AND_SAVE_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.COMMIT_AND_SAVE.full
  ],
  CONTRACT_AUDIT_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.CONTRACT_AUDIT.read,
    CORPORATE_PERMISSION_LEVELS.CONTRACT_AUDIT.full
  ],
  CONTRACT_AUDIT_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.CONTRACT_AUDIT.full
  ],
  REQUISTION_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.REQUISTION.read,
    CORPORATE_PERMISSION_LEVELS.REQUISTION.full
  ],
  REQUISTION_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.REQUISTION.full
  ],
  REGIONS_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.REGIONS.read,
    CORPORATE_PERMISSION_LEVELS.REGIONS.full
  ],
  REGIONS_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.REGIONS.full
  ],
  SSO_MANAGE_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.SSO_MANAGE.read,
    CORPORATE_PERMISSION_LEVELS.SSO_MANAGE.full
  ],
  SSO_MANAGE_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.SSO_MANAGE.full
  ],
  SUPPLIER_ACCOUNTS_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.SUPPLIER_ACCOUNTS.read,
    CORPORATE_PERMISSION_LEVELS.SUPPLIER_ACCOUNTS.full
  ],
  SUPPLIER_ACCOUNTS_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.SUPPLIER_ACCOUNTS.full
  ],
  BUDGETS_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.BUDGETS.read,
    CORPORATE_PERMISSION_LEVELS.BUDGETS.full
  ],
  BUDGETS_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.BUDGETS.full
  ],
  ALERTS_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.ALERTS.read,
    CORPORATE_PERMISSION_LEVELS.ALERTS.full
  ],
  ALERTS_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALERTS.full
  ],
  MISSED_SAVINGS_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.MISSED_SAVINGS.read
  ],
  PRICE_COMPARE_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.PRICE_COMPARE.read,
    CORPORATE_PERMISSION_LEVELS.PRICE_COMPARE.full
  ],
  PRICE_COMPARE_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.PRICE_COMPARE.full
  ],
  GUIDANCE_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.GUIDANCE.read,
    CORPORATE_PERMISSION_LEVELS.GUIDANCE.full
  ],
  GUIDANCE_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.GUIDANCE.full
  ],
  CASHBACK_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.CASHBACK.read
  ],
  VENDOR_BLACKLIST_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.VENDOR_BLACKLIST.read,
    CORPORATE_PERMISSION_LEVELS.VENDOR_BLACKLIST.full
  ],
  VENDOR_BLACKLIST_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.VENDOR_BLACKLIST.full
  ],
  CLINIC_INFO_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.CLINIC_INFO.read,
    CORPORATE_PERMISSION_LEVELS.CLINIC_INFO.full
  ],
  CLINIC_INFO_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.CLINIC_INFO.full
  ],
  INVOICE_STATEMENTS_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.INVOICE_STATEMENTS.read,
    CORPORATE_PERMISSION_LEVELS.INVOICE_STATEMENTS.full
  ],
  INVOICE_STATEMENTS_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.INVOICE_STATEMENTS.full
  ],
  INVOICES_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.INVOICES.read,
    CORPORATE_PERMISSION_LEVELS.INVOICES.full
  ],
  INVOICES_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.INVOICES.full
  ],
  MESSAGES_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.MESSAGES.read,
    CORPORATE_PERMISSION_LEVELS.MESSAGES.full
  ],
  MESSAGES_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.MESSAGES.full
  ],
  REGIONS_ACCESSIBLE: [
    CORPORATE_PERMISSION_LEVELS.REGIONS_ACCESSIBLE.read
  ],
  APPROVAL_RULES_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.APPROVAL_RULES.read,
    CORPORATE_PERMISSION_LEVELS.APPROVAL_RULES.full
  ],
  APPROVAL_RULES_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.APPROVAL_RULES.full
  ],
  APPROVAL_ORDERS_READ: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.read,
    CORPORATE_PERMISSION_LEVELS.APPROVAL_ORDERS.read,
    CORPORATE_PERMISSION_LEVELS.APPROVAL_ORDERS.full,
    CORPORATE_PERMISSION_LEVELS.APPROVAL_ORDERS.admin
  ],
  APPROVAL_ORDERS_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.APPROVAL_ORDERS.full,
    CORPORATE_PERMISSION_LEVELS.APPROVAL_ORDERS.admin
  ],
  ITEM_LINKS_FULL: [
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
    CORPORATE_PERMISSION_LEVELS.ITEM_LINKS.full
  ],
  SCRIPT_ASSIGN_CALLER_FULL: [
    CORPORATE_PERMISSION_LEVELS.SCRIPTS_ASSIGN_CALLER.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
  ],
  SCRIPT_BE_A_CALLER_FULL: [
    CORPORATE_PERMISSION_LEVELS.SCRIPTS_BE_A_CALLER.full
  ],
  GLCODES_FULL: [
    CORPORATE_PERMISSION_LEVELS.GLCODES.full,
    CORPORATE_PERMISSION_LEVELS.ALL_PERMISSIONS.full,
  ]
};

export const PERMISSION_GROUPS_FETCH = createAPIActions('PERMISSION_GROUPS_FETCH');
export const PERMISSION_GROUPS_CREATE = createAPIActions('PERMISSION_GROUPS_CREATE');
export const PERMISSION_GROUPS_UPDATE = createAPIActions('PERMISSION_GROUPS_UPDATE');
export const PERMISSION_GROUPS_DELETE = createAPIActions('PERMISSION_GROUPS_DELETE');

export const CORPORATE_VENDOR_LINK_UPDATE = createAPIActions('CORPORATE_VENDOR_LINK_UPDATE');
export const CORPORATE_VENDOR_LINK_FETCH = createAPIActions('CORPORATE_VENDOR_LINK_FETCH');

export const BUDGET_EXCLUDED_ITEMS_INSUFFICIENT_PERMISSIONS_MESSAGE = 'You do not have permission to edit budgets. '
+ 'If you think this is a mistake, please talk to your Corporate administrator.';
